"use client";

import * as React from "react";
import { ArrowUp, Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const socialLinks = [{
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-sm" />)}
      </ul>;
  }
  return <ul className="space-y-3 font-sans">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors inline-block">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  return <section id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <WvcLogo className="h-8 w-auto mb-6" />
            <p className="text-muted-foreground text-sm leading-relaxed font-sans max-w-xs">
              Expert home renovation, painting, and maintenance services delivering architectural precision and uncompromising quality for every project.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight">Navigation</h3>
            <MenuProvider menu_id="19">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight">Contact</h3>
            <ul className="space-y-4 text-sm text-muted-foreground font-sans">
              <li className="flex items-start gap-3">
                <Phone className="size-5 shrink-0 text-primary" />
                <span>954-681-5265</span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="size-5 shrink-0 text-primary" />
                <Link to="mailto:smith3bgroupllc@gmail.com" className="hover:text-primary transition-colors">
                  smith3bgroupllc@gmail.com
                </Link>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="size-5 shrink-0 text-primary" />
                <span>Serving the local area</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-semibold mb-6 tracking-tight">Connect</h3>
            <div className="flex gap-3">
              {socialLinks.map((social, i) => <Link key={i} data-index={i} to={social.href} aria-label={social.label} className="flex items-center justify-center size-10 border border-border rounded-sm text-muted-foreground hover:text-primary hover:border-primary transition-all bg-card/50 hover:bg-card">
                  <social.icon className="size-4" />
                </Link>)}
            </div>
          </div>

        </div>

        <Separator className="bg-border mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-muted-foreground font-sans">
          <p>© {new Date().getFullYear()} SMITH & B GROUP LLC. All rights reserved.</p>
          
          <Button variant="outline" size="sm" onClick={scrollToTop} className="rounded-sm border-border bg-transparent hover:bg-accent hover:text-accent-foreground transition-colors">
            Back to Top
            <ArrowUp className="ml-2 size-4" />
          </Button>
        </div>
      </div>
    </section>;
}